import { fetchAuthCodeValidity } from './api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const validateAuthCode = createAsyncThunk(
  'authCode/validate',
  async authCode => {
    return await fetchAuthCodeValidity(authCode);
  },
);

const sharingSlice = createSlice({
  name: 'sharing',
  initialState: {
    authCodeValid: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(validateAuthCode.fulfilled, (state, _) => {
      state.authCodeValid = true;
    });
    builder.addCase(validateAuthCode.rejected, (state, _) => {
      state.authCodeValid = false;
    });
  },
});

export const { setAuthCodeValid } = sharingSlice.actions;

export const reducer = sharingSlice.reducer;

export const getAuthCodeValidity = state => {
  return state.sharing.authCodeValid;
};
